<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/elements-content -->

<section class="header_sec card">
  <div class="flex justify-content-between w-full align-items-center gap-3">
    <div class="custom_sd_btn">
      <p-button
        class="close_btn"
        (click)="sidebarOnOff()"
        icon="pi pi-align-left"></p-button>
    </div>
    <div class="global-search-wrapper">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <div class="input_group">
          <input
            pInputText
            type="text"
            [value]="searchValue()"
            placeholder="Search modules, pages..."
            (input)="onSearch($event, searchOp)"
            (focus)="openIfHasData($event, searchOp)" />
        </div>
      </span>

      <p-overlayPanel
        #searchOp
        [dismissable]="true"
        styleClass="search-overlay">
        <p-listbox
          [options]="results()"
          optionLabel="title"
          [style]="{ width: '320px' }"
          (onChange)="navigate($event.value, searchOp)">
          <ng-template let-item pTemplate="item">
            <div class="search-item">
              <div class="title">{{ item.title }}</div>
              <div class="meta">{{ item.route }}</div>
            </div>
          </ng-template>
        </p-listbox>
      </p-overlayPanel>
    </div>
    <div class="flex gap-2 align-items-center">
      @if (
        popularGuides && popularGuides.length > 0 && profile.type !== 'AGENT'
      ) {
        <div class="btn_center w-full flex justify-content-center">
          <p-button
            label="Guides"
            routerLink="/web/help-center"
            severity="contrast" />
        </div>
      }
      @if (
        (sidebarData &&
          sidebarData.subItemId &&
          sidebarMultiModules.includes(sidebarData.subItemId)) ||
        (sidebarData && sidebarData.parentId && sidebarData.parentId === 11)
      ) {
        <p-dropdown
          optionLabel="name"
          optionValue="language_code"
          [options]="languages()"
          placeholder="{{ 'language' | translate }}"
          [(ngModel)]="lang"
          (onChange)="onStatusChange($event)">
        </p-dropdown>
      }
      @if (profile && profile.type === 'AGENT') {
        <div
          class="agent-active-toggle"
          [class.agent-active-toggle--on]="profile.active"
          [class.agent-active-toggle--off]="!profile.active">
          <span
            class="agent-active-toggle__indicator"
            aria-hidden="true"></span>
          <div class="agent-active-toggle__text">
            <span class="agent-active-toggle__label">{{
              'Agent Status' | translate
            }}</span>
            <span class="agent-active-toggle__status">
              {{ (profile.active ? 'Active' : 'InActive') | translate }}
            </span>
          </div>
          <span class="agent-active-toggle__divider" aria-hidden="true"></span>
          <p-inputSwitch
            [(ngModel)]="profile.active"
            (onChange)="onAgentActiveToggle($event)"></p-inputSwitch>
        </div>
      }
      <div class="relative bell cursor-pointer">
        <div
          #bellTrigger
          class="bell-trigger"
          (click)="
            notificationOp.toggle($event, bellTrigger); getNewNotification()
          ">
          <i class="pi pi-bell" style="font-size: 1.7rem"></i>
          @if (profile) {
            <span class="dot">{{ profile.notification_unread || 0 }}</span>
          }
        </div>

        <p-overlayPanel
          #notificationOp
          appendTo="body"
          styleClass="notification-overlay-panel"
          [dismissable]="true"
          hideTransitionOptions="0ms"
          [style]="{ width: '400px' }">
          <div class="mn_notification">
            <div class="notification-header">
              <h4 class="notification-header__title">Notifications</h4>
              @if (
                profile &&
                profile.notification_unread &&
                notificationData() &&
                notificationData().length > 0
              ) {
                <p-button
                  styleClass="notification-header__action"
                  (click)="$event.stopPropagation(); updateNotification()"
                  label="{{ 'Read All' | translate }}"
                  [raised]="true"
                  severity="contrast" />
              }
            </div>

            @if (notificationData() && notificationData().length > 0) {
              <div class="notification-item1">
                <ul
                  infiniteScroll
                  [infiniteScrollDistance]="1"
                  [infiniteScrollThrottle]="50"
                  [scrollWindow]="false"
                  (scrolled)="onScrollingFinished()">
                  @for (
                    list of notificationData();
                    track list.id;
                    let index = $index
                  ) {
                    <li
                      (click)="btn_redirect(list)"
                      [class.notification-viewed]="list.viewed">
                      <span class="notification-dot-slot" aria-hidden="true">
                        @if (!list.viewed) {
                          <span class="dot"></span>
                        }
                      </span>
                      <p>
                        {{ list.message
                        }}<span class="block">{{
                          list.created_at | date: 'dd/MM/YYYY hh:mm a'
                        }}</span>
                      </p>
                    </li>
                  }
                </ul>
              </div>
            } @else if (notificationData() && notificationData().length === 0) {
              <div class="noDataFound">
                <figure>
                  <img [src]="assetsConst.noNotification" alt="" />
                </figure>
                <p>
                  {{ 'noNotifications' | translate }}
                </p>
              </div>
            }
          </div>
        </p-overlayPanel>
      </div>
      <div
        routerLink="/profile"
        class="profile flex justify-content-center align-items-center gap-2"
        style="cursor: pointer">
        @if (profile) {
          <figure
            class="border-circle overflow-hidden w-3rem h-3rem flex justify-content-center align-items-center">
            <img
              [src]="profile.photo ? profile.photo : assetsConst.adminIcon"
              alt="Profile" />
          </figure>
          <a>{{ profile.name }}</a>
        }
      </div>
    </div>
  </div>
</section>
